'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dName$0024$0024anon$002484 from "./presto.types$-Policy-Name$$anon$84.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PolicyName$() {
  this.c8B = null;
  this.c8C = false;
  this.c8z = null;
  this.c8A = false;
  this.c8F = null;
  this.c8G = false;
  this.c8D = null;
  this.c8E = false;
}
export { $c_Lpresto_types$PolicyName$ as $c_Lpresto_types$PolicyName$ };
$p = $c_Lpresto_types$PolicyName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PolicyName$;
/** @constructor */
function $h_Lpresto_types$PolicyName$() {
}
export { $h_Lpresto_types$PolicyName$ as $h_Lpresto_types$PolicyName$ };
$h_Lpresto_types$PolicyName$.prototype = $p;
$p.cIj = (function() {
  if ((!this.c8C)) {
    this.c8B = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8C = true;
  }
  return this.c8B;
});
$p.a2C = (function() {
  if ((!this.c8A)) {
    this.c8z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c8A = true;
  }
  return this.c8z;
});
$p.cIT = (function() {
  if ((!this.c8G)) {
    this.c8F = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8G = true;
  }
  return this.c8F;
});
$p.cse = (function() {
  if ((!this.c8E)) {
    this.c8D = new $j_presto$002etypes$0024$002dPolicy$002dName$0024$0024anon$002484.$c_Lpresto_types$PolicyName$$anon$84(this);
    this.c8E = true;
  }
  return this.c8D;
});
$p.cF0 = (function(original) {
  var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Predef$();
  var xs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__split__T__I__AT(original, " ", 0);
  var evidence$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_reflect_ClassTag$().qN($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$objectGetClass(xs).aU.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.fg();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.b.length)) {
    var x1 = i;
    var x = xs.b[x1];
    if ((x !== "")) {
      var unboxedElem = (isCharArrayBuilder ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uC(x) : ((x === null) ? elementClass.aU.z : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var elemRuntimeClass = ((elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_V.l()) ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_jl_Void.l() : (((elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_sr_Null$.l()) || (elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_sr_Nothing$.l())) ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_O.l() : elementClass));
  var filtered = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_1.es(elemRuntimeClass.aU.r().w(jsElems)), "", " ", "");
  return ((!(!original.endsWith(" "))) ? (filtered + " ") : filtered);
});
var $d_Lpresto_types$PolicyName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PolicyName$, "presto.types$PolicyName$", ({
  a0P: 1,
  D: 1
}));
export { $d_Lpresto_types$PolicyName$ as $d_Lpresto_types$PolicyName$ };
var $n_Lpresto_types$PolicyName$;
function $m_Lpresto_types$PolicyName$() {
  if ((!$n_Lpresto_types$PolicyName$)) {
    $n_Lpresto_types$PolicyName$ = new $c_Lpresto_types$PolicyName$();
  }
  return $n_Lpresto_types$PolicyName$;
}
export { $m_Lpresto_types$PolicyName$ as $m_Lpresto_types$PolicyName$ };
//# sourceMappingURL=presto.types$-Policy-Name$.js.map
